import { Icon } from "@iconify/react/dist/iconify.js"
import AppDialog from "../../../components/Common/AppDialog"
import { Box, FormControlLabel, Grid, Radio, Stack } from "@mui/material";
import Label from "../../../components/Common/Label";
import Helpers from "../../../helpers/helpers";
import SearchBar from "../../../components/Common/Searchbar";
import { useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { getGeneral, searchGeneral } from "../../../store/actions";

const MakeModelChoosingModal = ({ open, close, handleSubmit, requestNewOpen, windowWidth, makeList, formObj, handleFormChange, setFormObj, setNotification, setIsLoading }) => {
    const [search, setSearch] = useState("");
    const [modelListing, setModelListing] = useState("");
    const [selectedMake, setSelectedMake] = useState();
    const [makeSearch, setMakeSearch] = useState();
    const [selectedModel, setSelectedModel] = useState();
    const [page, setPage] = useState(1);
    const searchRef = useRef(search);
    const dispatch = useDispatch();

    useEffect(() => {
        searchRef.current = search || '';
    }, [search]);

    useEffect(() => {
        if (makeList) {
            setIsLoading(false);
        }
    }, [makeList]);

    useEffect(() => {
        setPage(1);
    }, []);

    const handleSearch = (text) => {
        setSearch(text);
        setTimeout(() => {
            if (text === searchRef.current) {
                setIsLoading(true);
                dispatch(searchGeneral({ type: page === 1 ? "bike_makes" : "bike_models", search: text }));
            }
        }, Helpers.searchInterval);
    }

    const handleClose = () => {
        setSelectedMake();
        setSelectedModel();
        setFormObj(prev => ({ ...prev, "vehicle": {} }));
        close();
    }

    // const modelSectionRef = useRef(null);
    // const modelListing = makeList?.find((model) => model.id === formObj?.bike_make_id)?.models;

    const handleMakeSelect = (make) => {
        handleFormChange('bike_make_id', make?.id);
        setModelListing(make?.models || [])
    };

    const handleProceed = () => {
        if (page === 1) {
            if (!formObj?.bike_make_id) {
                setNotification({ open: true, msg: "Please select a make to proceed.", type: "error" });
                return;
            }
            setPage(2);
            // setSearch("");
        } else {
            if (!formObj?.bike_model_id) {
                setNotification({ open: true, msg: "Please select a model to proceed.", type: "error" });
                return;
            }
            else {
                handleSubmit(selectedModel)
                setPage(1)
                setMakeSearch("");
            }
        }
    }

    const handleBack = () => {
        if (page === 2) {
            setPage(1);
            // handleSearch("")
        } else {
            handleClose();
        }
    }
    const handleSearchModel = (e) => {
        setMakeSearch(e);
        const filteredModel = makeList?.length > 0 && makeList?.find((make) => make.id === formObj?.bike_make_id)?.models
        setModelListing(filteredModel?.filter((model) => model.name.toLowerCase().includes(e.toLowerCase())));
    }

    return (
        <AppDialog
            title={'Choose the make and model'}
            open={open}
            close={handleClose}
            isMobile={windowWidth <= 768 ? true : false}
            positiveTitle={`${page === 1 ? 'Next' : 'Select'}`}
            positivePress={() => { handleProceed() }}
            negativeTitle={`${page === 1 ? 'Cancel' : 'Back'}`}
            negativePress={() => handleBack()}
            negativeButtonStyle={{ border: "1px solid #F9F9F9", backgroundColor: '#F9F9F9', color: '#808588', width: "auto", borderRadius: 20, width: windowWidth <= 768 ? '100%' : 'auto' }}
            textOnButtonBar={
                <div className={windowWidth <= 768 ? "" : "d-flex"} style={{ width: '100%' }}>
                    Can’t find your make or model?
                    <div style={{ color: '#B48A3C', marginLeft: 5, cursor: 'pointer' }} onClick={() => { requestNewOpen(true) }}>Request to add a new one.</div>
                </div>
            }
        >
            <Box style={{ position: "sticky", top: 0, zIndex: 1, backgroundColor: "#fff", height: "40px" }}>
                <div style={{ backgroundColor: "#fff", paddingTop: 5, paddingBottom: 5, width: "100%" }}>
                    {page === 1 ?
                        <SearchBar
                            value={search}
                            module="make"
                            setValue={(e) => handleSearch(e)}
                        />

                        :
                        <SearchBar
                            value={makeSearch || ""}
                            module="model"
                            setValue={(e) => handleSearchModel(e)}
                        />

                    }
                </div>

            </Box>
            <Grid container spacing={2} mt={2} >
                {
                    page === 1 ? makeList ? makeList?.length > 0 && makeList?.map((make) => (
                        <>
                            <Grid item lg={2} md={3} sm={6} xs={12} >
                                <Box className={`make-model-info d-flex align-items-center ${formObj?.bike_make_id === make?.id ? ' selected-make-model-info' : ''}`} onClick={() => handleMakeSelect(make)} sx={{ minHeight: { xs: "auto", sm: "150px" }, justifyContent: { xs: "flex-start", sm: "center" } }}>
                                    <Stack direction={{ xs: "row", sm: "column" }} alignItems="center" spacing={1}>
                                        <img src={make?.images?.[0]?.attachment_path || Helpers.noLogo} alt={`make-img-${make?.id}`} style={{ width: 48, height: 40, objectFit: 'contain' }} />
                                        <div className="mt-2 text-center">{make?.name || '-'}</div>
                                    </Stack>
                                </Box>
                            </Grid>
                        </>
                    )) : <div className="subheader-2">No make found.</div> : ""
                }
                {
                    page === 2 && formObj?.bike_make_id &&
                    <Grid item xs={12} >
                        <div className="">
                            <div className="subheader-2 mb-2">Choose the model of the motorcycle.</div>
                            <Grid container spacing={2}>
                                {
                                    modelListing && modelListing.length > 0 ? modelListing?.map((model) => (
                                        <Grid item md={6} xs={12} onClick={() => {
                                            handleFormChange('bike_model_id', model?.id); setSelectedModel(model);
                                        }} style={{ cursor: "pointer" }}>
                                            <div className={`dashboard-card p-3 d-flex align-items-center ${formObj?.bike_model_id === model?.id ? ' selected-make-model-info' : ''}`} >
                                                <div style={{ width: '90%' }}>{model?.name || '-'}</div>
                                                <div >
                                                    <FormControlLabel
                                                        checked={formObj?.bike_model_id === model?.id}
                                                        value={model?.id}
                                                        onClick={() => { handleFormChange('bike_model_id', model?.id); setSelectedModel(model) }}
                                                        key={model?.id}
                                                        style={{ fontFamily: 'FunnelSans', fontSize: 14, marginBottom: 0 }}
                                                        control={<Radio
                                                            sx={{
                                                                '&.Mui-checked': {
                                                                    color: "#1D1B1B",
                                                                },
                                                                '& .MuiSvgIcon-root': {
                                                                    fontSize: 20,
                                                                },

                                                            }} />}
                                                    />
                                                </div>
                                            </div>
                                        </Grid>
                                    )) : <Grid item xs={12} className="subheader font-size-13">No model found for the selected make.</Grid>
                                }

                            </Grid>
                        </div>
                    </Grid>
                }
            </Grid>

        </AppDialog>
    )
}

function mapStateToProps({ General }) {
    return {
        makeList: General.bike_make_search,
        // modelList: General.bike_models,
        bodyList: General.bike_types,
        license_categories: General.license_categories,
    };
}

export default connect(mapStateToProps)(MakeModelChoosingModal);